import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AgentSubscriptionBannerComponent } from '../components/subscription-banner/agent-subscription-banner.component';

@Component({
  selector: 'etxe-agent-layout-wrapper',
  imports: [RouterOutlet, AgentSubscriptionBannerComponent],
  template: `
    <etxe-agent-subscription-banner />
    <div class="flex flex-1 flex-col min-h-0 w-full">
      <router-outlet />
    </div>
  `,
  host: {
    class: 'flex flex-col flex-1 min-h-0 w-full',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentLayoutWrapperComponent {}
